import { loadExternalScript } from '~/utils/third-party-scripts'

const PREFERRED_SOURCES_SCRIPT_ID = 'google-preferred-sources-script'
const PREFERRED_SOURCES_SCRIPT_URL = 'https://news.google.com/swg/js/v1/publisher.js'
const clientPromises = new WeakMap()

export function loadPreferredSources({
    windowObject = window,
    scriptLoader = loadExternalScript,
} = {}) {
    const existingApi = windowObject.PREFERRED_SOURCE?.api
    if (existingApi) {
        return Promise.resolve(existingApi)
    }

    const existingPromise = clientPromises.get(windowObject)
    if (existingPromise) {
        return existingPromise
    }

    const clientPromise = new Promise((resolve, reject) => {
        const onReady = api => resolve(api)
        windowObject.PREFERRED_SOURCE = windowObject.PREFERRED_SOURCE || []
        windowObject.PREFERRED_SOURCE.push(onReady)

        scriptLoader({
            id: PREFERRED_SOURCES_SCRIPT_ID,
            src: PREFERRED_SOURCES_SCRIPT_URL,
            attributes: {
                'preferred-sources-control': 'manual',
            },
            documentObject: windowObject.document,
        }).catch((error) => {
            if (Array.isArray(windowObject.PREFERRED_SOURCE)) {
                const callbackIndex = windowObject.PREFERRED_SOURCE.indexOf(onReady)
                if (callbackIndex >= 0) {
                    windowObject.PREFERRED_SOURCE.splice(callbackIndex, 1)
                }
            }

            clientPromises.delete(windowObject)
            reject(error)
        })
    })

    clientPromises.set(windowObject, clientPromise)
    return clientPromise
}

export async function preparePreferredSource(options = {}) {
    const api = await loadPreferredSources(options)
    api.init({
        lang: 'en',
        theme: 'light',
    })
    return api
}
